import type { ReactNode } from "react";

interface BannerProps {
  variant: "green" | "amber" | "subtle";
  children: ReactNode;
  action?: ReactNode;
  onClose: () => void;
}

export function Banner({ variant, children, action, onClose }: BannerProps) {
  return (
    <div className={`banner banner-${variant}`}>
      <div>{children}</div>
      {action ? (
        <div
          style={{
            alignItems: "center",
            display: "flex",
            flexShrink: 0,
            gap: 8,
          }}
        >
          {action}
          <button className="banner-close" onClick={onClose} type="button">
            ×
          </button>
        </div>
      ) : (
        <button className="banner-close" onClick={onClose} type="button">
          ×
        </button>
      )}
    </div>
  );
}
